import { GET, POST, PUT, DELETE } from "../../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchOfficeRequest = () =>
  GET("entitlement/ou").pipe(map((response: any) => response));

export const fetchGetSections = () =>
  GET("module/sections").pipe(map((response: any) => response));

export const fetchCreateSections = (body: any[]) =>
  POST("module/sections", body).pipe(map((response: any) => response));

export const fetchDeleteSections = (body: string[]) =>
  POST("module/sections/delete", body).pipe(map((response: any) => response));

export const fetchUpdateSection = (body: any[]) =>
  PUT("module/sections", body).pipe(map((response: any) => response));

export const fetchGetAttachments = (sectionId: string) =>
  GET(`module/sections/${sectionId}/attachments`).pipe(
    map((response: any) => response)
  );

export const fetchDeleteAttachments = (attachmentId: string) =>
  DELETE(`attachments/${attachmentId}`).pipe(map((response: any) => response));

export const fetchSaveAttachments = (formdata: FormData) => {
  return POST(
    "module/sections/attachments",
    formdata,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));
};

export const fetchGetAllRoles = () =>
  GET("authentication/admin/view-roles").pipe(map((response: any) => response));

export const fetchGetRoleInAttachment = (attachmentId: string) =>
  GET(`attachments/${attachmentId}/visibilityRoles`).pipe(
    map((response: any) => response)
  );

export const fetchUploadRolesInAttachment = (
  attachmentId: string,
  body: any[]
) =>
  PUT(`attachments/${attachmentId}/visibilityRoles`, body).pipe(
    map((response: any) => response)
  );
